'use client';

const Empty = ({}: any) => {
    return <></>;
};

export default Empty;
